<template>
  <Card :padding="false">
    <template slot="header">Commercial Use Permits</template>
    <v-btn
      color="primary"
      dark
      class="mb-2"
      @click="editModal=true"
    >
      Create
    </v-btn>
    <!-- start edit modal-->
    <Modal
      :visible="editModal"
      :ok-visible="true"
      :cancel-visible="true"
      ok-text="Save"
      @ok="save"
      @cancel="close"
    >
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-layout column>
          <!-- identification -->
          <v-text-field
            v-model="editedItem.businessName"
            :rules="[validationRules.required]"
            label="Business Name"
          />
          <v-text-field
            v-model="editedItem.businessSize"
            label="Business Size"
          />
          <v-text-field
            v-model="editedItem.address"
            :rules="[validationRules.required]"
            label="Address"
          />
          <v-text-field
            v-model="editedItem.city"
            :rules="[validationRules.required]"
            label="City"
          />
          <v-text-field
            v-model="editedItem.state"
            :rules="[validationRules.required]"
            label="State"
          />
          <v-text-field
            v-model="editedItem.zip"
            :rules="[validationRules.required]"
            label="Zip Code"
          />
          <v-text-field
            v-model="editedItem.businessPhone"
            :rules="[validationRules.required]"
            label="Business Phone"
          />
          <v-text-field
            v-model="editedItem.ownerName"
            :rules="[validationRules.required]"
            label="Owner Name"
          />
          <v-text-field
            v-model="editedItem.ownerPhone"
            :rules="[validationRules.required]"
            label="Owner Phone"
          />
          <v-checkbox
            v-model="editedItem.ownerIsContact"
            label="Owner is contact"
          />
          <template v-if="!editedItem.ownerIsContact">
            <v-text-field
              v-model="editedItem.contactName"
              label="Contact Name"
            />
            <v-text-field
              v-model="editedItem.contactPhone"
              label="Contact Phone"
            />
          </template>
          <v-text-field
            v-model="editedItem.email"
            :rules="[validationRules.required, validationRules.email]"
            label="Email"
          />
          <v-select
            v-model="editedItem.primaryActivity"
            :rules="[validationRules.required]"
            :items="activities"
            item-text="description"
            item-value="category"
            label="Primary Activity"
          />
          <v-select
            v-model="editedItem.secondaryActivity"
            :items="activities"
            item-text="description"
            item-value="category"
            label="Secondary Activity"
          />
          <v-select
            v-model="editedItem.tertiaryActivity"
            :items="activities"
            item-text="description"
            item-value="category"
            label="Tertiary Activity"
          />
          <v-checkbox
            v-model="editedItem.activePrior"
            label="Active at BSP Prior to 2019"
          />
          <v-textarea
            v-model="editedItem.note"
            label="Note"
            outline
          />
        </v-layout>
      </v-form>
    </Modal>
    <!-- end edit modal-->
    <!-- start members modal-->
    <Modal
      :visible="membersModal"
      :ok-visible="true"
      ok-text="Close"
      title="Members"
      @ok="membersModal = false"
      @cancel="membersModal = false"
    >
      <v-layout column>
        <h3> Add </h3>
        <v-layout row>
          <v-text-field
            v-model="searchTerm"
            flat
            hide-details
            prepend-inner-icon="search"
            label="Find User"
            @keyup.enter.native="searchMembers()"
          />
          <v-btn
            class="pt-1"
            @click="searchMembers()">
            Search
          </v-btn>
        </v-layout>
        <v-data-table
          :headers="memberHeaders"
          :items="searchResults"
        >
          <template
            slot="items"
            slot-scope="props"
          >
            <td>
              {{ props.item.firstName }} {{ props.item.lastName }} ({{ props.item.personID }})<br>
              {{ props.item.email }}<br>
              {{ props.item.phone1 }}
            </td>
            <td>
              {{ props.item.emergencyContactName }}<br>
              {{ props.item.emergencyContactPhone }}
            </td>
            <td class="text-xs-right">
              <IconButton
                :icon="props.item.commercialPermitID == commercialPermits[editedIndex].commercialPermitID ? 'fa-times' : 'fa-plus'"
                :color="props.item.commercialPermitID == commercialPermits[editedIndex].commercialPermitID ? 'red' : 'blue'"
                tooltip="Add/Remove"
                @click="toggleMember(props.item.personID)"
              />
            </td>
          </template>
        </v-data-table>
        <h3> Members </h3>
        <v-data-table
          :headers="memberHeaders"
          :items="members"
        >
          <template
            slot="items"
            slot-scope="props"
          >
            <td>
              {{ props.item.firstName }} {{ props.item.lastName }} ({{ props.item.personID }})<br>
              {{ props.item.email }}<br>
              {{ props.item.phone1 }}
            </td>
            <td>
              {{ props.item.emergencyContactName }}<br>
              {{ props.item.emergencyContactPhone }}
            </td>
            <td class="text-xs-right">
              <IconButton
                icon="fa-times"
                color="red"
                tooltip="Delete"
                @click="toggleMember(props.item.personID)"
              />
            </td>
          </template>
        </v-data-table>
      </v-layout>
    </Modal>
    <!-- end members modal-->
    <!-- start table -->
    <v-data-table
      :headers="commercialPermitHeaders"
      :items="commercialPermits"
      hide-actions
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <td>
          <strong>#{{ props.item.commercialPermitID }} {{ props.item.businessName }}</strong><br>
          Size: {{ props.item.businessSize }}<br>
          <span v-if="props.item.activePrior"> Active at BSP Prior to 2019</span>
        </td>
        <td>
          {{ props.item.primaryActivity }}<br>
          {{ props.item.secondaryActivity }}<br>
          {{ props.item.tertiaryActivity }}<br>
        </td>
        <td>
          {{ props.item.address }}<br>
          {{ props.item.city }}, {{ props.item.state }} {{ props.item.zip }}<br>
          ({{ props.item.businessPhone }})
        </td>
        <td>
          {{ props.item.email }}<br>
          Owner: {{ props.item.ownerName }} ({{ props.item.ownerPhone }})<br>
          Contact: {{ props.item.ownerIsContact ? props.item.ownerName : props.item.contactName }} ({{ props.item.ownerIsContact ? props.item.ownerPhone : props.item.contactPhone }})
        </td>
        <td class="text-xs-right">
          <IconButton
            icon="fa-edit"
            tooltip="Edit"
            @click="editItem(props.index)"
          />
          <IconButton
            icon="fa-users"
            tooltip="Members"
            @click="editMembers(props.index)"
          />
          <IconButton
            icon="fa-times"
            color="red"
            tooltip="Delete"
            @click="deleteItem(props.index)"
          />
        </td>
      </template>
    </v-data-table>
    <!-- end table modal-->
  </Card>
</template>

<script>
// import vuex mapping
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      valid: false,
      editModal: false,
      membersModal: false,
      searchTerm: '',
      personID: '',
      activities: [
        { category: 'shuttles', description: 'Transportation (Shuttle Service, Taxi, Sight Seeing tours, etc.)' },
        { category: 'guides', description: 'Guiding for Outdoor Recreation (fishing, hiking, skiing, mountaineering, etc.)' },
        { category: 'groups', description: 'Camp Groups (organized activities for children or adults)' },
        { category: 'workshops', description: 'Work Shops (photography, writing, painting, etc.)' }
      ],
      commercialPermitHeaders: [
        {
          text: 'Business',
          sortable: false
        },
        {
          text: 'Activities',
          sortable: false
        },
        {
          text: 'Address',
          sortable: false
        },
        {
          text: 'Contact',
          sortable: false
        },
        {
          text: '',
          align: 'right',
          sortable: false
        }
      ],
      memberHeaders: [
        {
          text: 'User',
          sortable: false
        },
        {
          text: 'Emergency Contact',
          sortable: false
        },
        {
          text: '',
          align: 'right',
          sortable: false
        }
      ],
      editedIndex: -1,
      editedItem: {}
    }
  },
  computed: {
    ...mapGetters({
      commercialPermits: 'commercialPermits/commercialPermits',
      members: 'commercialPermits/people',
      searchResults: 'person/searchResults'
    })
  },
  mounted () {
    this.getCommercialPermits()
  },
  methods: {
    ...mapActions({
      getCommercialPermits: 'commercialPermits/getCommercialPermits',
      createCommercialPermit: 'commercialPermits/createCommercialPermit',
      deleteCommercialPermit: 'commercialPermits/deleteCommercialPermit',
      updateCommercialPermit: 'commercialPermits/updateCommercialPermit',
      getPeopleByCommercialPermit: 'commercialPermits/getPeopleByCommercialPermit',
      searchPeople: 'person/searchPeople'
    }),
    editItem (index) {
      this.editedIndex = index
      this.editedItem = this.commercialPermits[index]
      this.editModal = true
    },
    refreshMembers () {
      return this.getPeopleByCommercialPermit({ commercialPermitID: this.commercialPermits[this.editedIndex].commercialPermitID })
    },
    editMembers (index) {
      this.editedIndex = index
      this.refreshMembers().then(() => {
        this.membersModal = true
      })
    },
    searchMembers () {
      this.searchPeople({ searchTerm: this.searchTerm })
    },
    toggleMember (personID) {
      this.updateCommercialPermit({ commercialPermitID: this.commercialPermits[this.editedIndex].commercialPermitID, personID: personID || this.personID }).then(() => {
        this.personID = null
        this.refreshMembers()
        this.searchMembers()
      })
    },
    deleteItem (index) {
      let confirmation = confirm('Are you sure you want to delete this permit?')
      if (confirmation) {
        this.deleteCommercialPermit({ commercialPermitID: this.commercialPermits[index].commercialPermitID })
      }
    },
    close () {
      this.editModal = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      if (this.$refs.form.validate()) {
        if (this.editedIndex === -1) {
          this.createCommercialPermit(this.editedItem)
        } else {
          this.updateCommercialPermit(this.editedItem)
        }
        this.close()
      }
    }
  }
}
</script>
